export const scssManifest = [
  'questionnaire-1003',
  'app-shell',
  'app-header',
  'common',
  'components',
  'app-progress',
  'welcome',
  'welcome-simple',
  'welcome-pop',
  'pages',
]
